// extracted by mini-css-extract-plugin
export default {"root":"Context_root__QooJG","title":"Context_title__zGxGf","description":"Context_description__497HR"};